import React, { useEffect, useState } from "react";
import EnterpriseGridCommon from "./Ag-Grid";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useSelector } from "react-redux";

const StatusConfigurationGrid = ({ rows, columns, isLoading }) => {
  const toggleProjectListState = useSelector(
    (state) => state?.switchThemeReducer?.toggleProjectList
  );

  const toggleProjectDetailsState = useSelector(
    (state) => state?.switchThemeReducer?.toggleProjectDetails
  );

  let heightValue;

  if (!toggleProjectDetailsState && toggleProjectListState) {
    heightValue = -395;
  } else if (toggleProjectDetailsState && !toggleProjectListState) {
    heightValue = -350;
  } else if (!toggleProjectDetailsState && !toggleProjectListState) {
    heightValue = -275;
  } else if (toggleProjectDetailsState && toggleProjectListState) {
    heightValue = -470;
  }

  function resolveNested(obj, path) {
    return path.split(".").reduce((o, key) => (o ? o[key] : undefined), obj);
  }

  const unitsCommonFilter = {
    pivot: true,
    floatingFilter: true,
    filter: "agMultiColumnFilter",
    filterParams: {
      maxNumConditions: 1,
      filters: [
        {
          filter: "agNumberColumnFilter",
          filterParams: {
            valueFormatter: (params) => {
              return Number(params.value);
            },
            maxNumConditions: 1,
          },
        },
      ],
    },
    valueGetter: (params) => {
      const value = resolveNested(params.data, params.colDef.field);
      return value === "" ? null : Number(value);
    },
    cellRenderer: (params) => {
      if (params.value === 0) return "0";
      if (
        params.value === "" ||
        params.value === null ||
        params.value === undefined
      )
        return "";
      return params.value;
    },
    pivotComparator: (a, b) => b.localeCompare(a),
  };

  const [columnDefs, setColumnDef] = useState([
    {
      headerName: "Parameter",
      field: "parameter",
      key: "parameter",
      pinned: "left",
      minWidth: 150,

      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
        cellHeight: 30,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
  ]);

  useEffect(() => {
    setColumnDef([
      {
        headerName: "Parameter",
        field: "parameter",
        key: "parameter",
        pinned: "left",
        minWidth: 150,

        pivot: true,
        floatingFilter: true,
        filter: "agMultiColumnFilter",
        filterParams: {
          maxNumConditions: 1,
          cellHeight: 30,
        },
        pivotComparator: (a, b) => b.localeCompare(a),
      },
      // eslint-disable-next-line no-unsafe-optional-chaining
      ...columns?.map((ite) => {
        return {
          headerName: ite.columnName,
          field: ite.value,
          key: ite.value,
          minWidth: 150,
          ...unitsCommonFilter,
        };
      }),
    ]);
  }, [columns]);

  const processCellCallback = (params) => {
    if (params?.column?.colDef?.processCellForExport) {
      return params.column.colDef.processCellForExport(params);
    }
    return params.value;
  };

  return (
    <div
      className="ag-theme-alpine slog-grid-container"
      style={{ width: "100%" }}
    >
      <EnterpriseGridCommon
        rows={rows}
        columnDefs={columnDefs}
        isLoading={isLoading}
        exportFileName={"status-configuration"}
        processCellCallback={processCellCallback}
        heightValue={heightValue}
        slogData={true}
      />
    </div>
  );
};

export default StatusConfigurationGrid;
